import { useCallback } from 'react'
import { ClipboardHistoryItem } from '../types'
import { useQueryClient } from '@tanstack/react-query'
import { useActions } from '../providers'

export const useDeleteClipboardItem = () => {
  const { deleteClipboardItem: deleteItem } = useActions()
  const queryClient = useQueryClient()

  return useCallback(
    async (id: number) => {
      deleteItem(id)

      // Remove item from all clipboard history query caches
      queryClient.setQueriesData({ queryKey: ['clipboardHistory'] }, (stale: ClipboardHistoryItem[] | undefined) => {
        if (!stale) {
          return stale
        }
        return stale.filter((item) => item.id !== id)
      })
    },
    [deleteItem, queryClient],
  )
}

export const useInvalidateClipboardHistory = () => {
  const queryClient = useQueryClient()
  return useCallback(async () => {
    await queryClient.invalidateQueries({ queryKey: ['clipboardHistory'] })
  }, [queryClient])
}
